export default "__VITE_ASSET__DvK6rOkU__"